import { motion } from "framer-motion";
import { Heart, X } from "lucide-react";
import { imgSrc } from "./repApi";

/* পণ্যের উপস্থাপনা — ডান-পাল্লা (ডেস্কটপ) / নিচের-পাতা (মোবাইল); চিত্রা পাশেই থাকেন */
export default function ProductDetail({ product, saved, toggleSave, onClose, onTryon, onOrder, onBargain }) {
  if (!product) return null;
  const isSaved = saved.includes(product.id);
  return (
    <motion.div
      className="fixed inset-0 z-[88] bg-dusk/60 backdrop-blur-[3px]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
      data-testid="shop-detail-veil"
    >
      <motion.aside
        initial={{ x: "110%" }}
        animate={{ x: 0 }}
        exit={{ x: "110%" }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        onClick={(e) => e.stopPropagation()}
        className="absolute inset-x-0 bottom-0 max-h-[86vh] overflow-y-auto rounded-t-2xl border border-gold/25 bg-plaster sm:inset-y-0 sm:left-auto sm:right-0 sm:max-h-none sm:w-[460px] sm:rounded-none sm:rounded-l-2xl"
        data-testid="shop-product-detail"
      >
        <button
          data-testid="detail-close"
          onClick={onClose}
          className="absolute right-4 top-4 z-10 rounded-full bg-dusk/70 p-2 text-sand/70 backdrop-blur-md transition-colors hover:text-sand"
          aria-label="বন্ধ করুন"
        >
          <X size={16} />
        </button>
        <div className="relative h-64 sm:h-[340px]">
          <img src={imgSrc(product.img)} alt={product.title} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-plaster via-transparent to-transparent" />
        </div>
        <div className="p-6 sm:p-7">
          <span className="rounded-full border border-gold/25 px-3 py-1 text-[10px] tracking-wide text-gold/90">{product.tag}</span>
          <h3 className="mt-3 font-display text-3xl leading-snug text-sand">{product.title}</h3>
          <p className="mt-1 font-latin text-xs italic text-sand/45">{product.latin}</p>
          <p className="mt-3 font-display text-2xl text-gold" data-testid="detail-price">{product.price}</p>

          <p className="mt-4 text-sm leading-relaxed text-sand/75">{product.story}</p>

          <dl className="mt-5 space-y-2 text-sm">
            <div className="flex gap-3">
              <dt className="w-20 shrink-0 text-sand/45">শিল্পী</dt>
              <dd className="text-sand/85">{product.artisan}</dd>
            </div>
            <div className="flex gap-3">
              <dt className="w-20 shrink-0 text-sand/45">কারুকাজ</dt>
              <dd className="text-sand/85">{product.craft}</dd>
            </div>
            <div className="flex gap-3">
              <dt className="w-20 shrink-0 text-sand/45">মাপ</dt>
              <dd className="flex flex-wrap gap-1.5 text-sand/85" data-testid="detail-sizes">
                {(product.sizes || []).map((s) => (
                  <span key={s} className="rounded-full border border-sand/25 px-2.5 py-0.5 text-xs">{s}</span>
                ))}
              </dd>
            </div>
            <div className="flex gap-3">
              <dt className="w-20 shrink-0 text-sand/45">উপাদান</dt>
              <dd className="text-sand/85">{product.material}</dd>
            </div>
          </dl>

          <p className="mt-4 rounded-xl border border-gold/15 bg-earthen/60 p-3 text-xs leading-relaxed text-sand/65">
            {product.custom_order ? "নিজের মাপ-রঙে হাতে বানানো যাবে — দোকানে বললেই হবে। " : ""}
            {product.delivery}
          </p>

          <div className="mt-6 flex flex-wrap gap-2.5">
            {product.tryon && (
              <button
                data-testid="detail-tryon"
                onClick={() => onTryon(product)}
                className="rounded-full bg-vermilion px-5 py-2.5 text-sm font-medium text-alpana transition-all duration-300 hover:scale-105"
              >
                নিজের উপর দেখে নিন
              </button>
            )}
            <button
              data-testid="detail-save"
              onClick={() => toggleSave(product.id)}
              className={`flex items-center gap-2 rounded-full px-5 py-2.5 text-sm transition-all duration-300 ${
                isSaved ? "bg-vermilion text-alpana" : "border border-gold/40 text-gold hover:bg-gold hover:text-dusk"
              }`}
            >
              <Heart size={14} className={isSaved ? "fill-alpana" : ""} />
              {isSaved ? "পছন্দে জমা আছে" : "পছন্দে রাখুন"}
            </button>
            <button
              data-testid="detail-order"
              onClick={() => onOrder(product)}
              className="rounded-full bg-alpana px-5 py-2.5 text-sm font-medium text-dusk transition-all duration-300 hover:scale-105"
            >
              অর্ডার করুন
            </button>
            <button
              data-testid="detail-bargain"
              onClick={onBargain}
              className="rounded-full border border-sand/25 px-5 py-2.5 text-sm text-sand/80 transition-colors hover:border-gold hover:text-gold"
            >
              দাম নিয়ে কথা বলি
            </button>
          </div>
        </div>
      </motion.aside>
    </motion.div>
  );
}
